import { Fragment } from 'react'

import {
  FeatureFlagsSchemaEntry,
  FeatureFlagsSchemaObjectEntry,
  FeatureFlagValue,
  GenericFeatureFlags,
} from 'domains/featureFlags'
import { getValueByPath } from 'utils/getValueByPath'

import { FeatureFlagItem } from './FeatureFlagItem'
import { FeatureFlagObject } from './FeatureFlagObject'

interface FeatureFlagRootObjectProps {
  ffSchemaObject: FeatureFlagsSchemaObjectEntry
  dbFFObject: GenericFeatureFlags
}

interface PropertyTempData {
  ffKey: string
  ffData: FeatureFlagsSchemaObjectEntry | FeatureFlagsSchemaEntry
}

const defaultGroupName = 'misc'

export const FeatureFlagRootObject = ({
  ffSchemaObject,
  dbFFObject,
}: FeatureFlagRootObjectProps) => {
  const visibleProperties: PropertyTempData[] = Object.entries(ffSchemaObject.properties)
    .map((entry) => ({
      ffKey: entry[0],
      ffData: entry[1],
    }))
    .filter((permission) => permission.ffData.visible)

  const permissionGroups = visibleProperties.reduce(
    (acc, item) => {
      const key = item.ffData.group ?? defaultGroupName

      if (!acc[key]) {
        acc[key] = []
      }

      acc[key].push(item)

      return acc
    },
    {} as Record<string, PropertyTempData[]>,
  )

  return (
    <>
      {Object.entries(permissionGroups).map((permissionGroup, index) => {
        const showDivider = index > 0
        const groupData = permissionGroup[1]

        return (
          <Fragment key={groupData[0].ffKey}>
            {showDivider && <hr />}
            <div className="d-flex flex-column" style={{ gap: '1rem' }}>
              {groupData.map((permission) =>
                permission.ffData.type === 'object' ? (
                  <FeatureFlagObject
                    key={permission.ffKey}
                    path={[permission.ffKey]}
                    ffSchemaObject={permission.ffData}
                    dbFFObject={getValueByPath(dbFFObject, permission.ffKey) as GenericFeatureFlags}
                    nested={Boolean(permission.ffData.dependentOn)}
                  />
                ) : (
                  <FeatureFlagItem
                    key={permission.ffKey}
                    path={[permission.ffKey].join('.')}
                    ffSchemaItem={permission.ffData}
                    dbFFItem={
                      getValueByPath(dbFFObject, permission.ffKey) as
                        | FeatureFlagValue
                        | FeatureFlagValue[]
                    }
                    nested={Boolean(permission.ffData.dependentOn)}
                  />
                ),
              )}
            </div>
          </Fragment>
        )
      })}
    </>
  )
}
